import React, { useState } from "react";
import { ModalWrapper } from "../../styled";
import { ConfigProvider, Button } from "antd";
import TextArea from "antd/es/input/TextArea";
import ptBR from "antd/lib/locale/pt_BR";
import dayjs from "dayjs";
import { Method_POST } from "../../../../../../../service/api";
import { toast } from "react-toastify";
import { Box, CircularProgress } from "@mui/material";
import { formatCNPJ } from "../../../../../../../function/utilis/function";
import styles from "./GroupOrdemServico.module.css";

/** Um par rótulo/valor. Mostra um placeholder em itálico quando o dado não veio preenchido. */
function Campo({ rotulo, valor, largo }) {
  const vazio = valor === null || valor === undefined || valor === "";
  return (
    <div className={`${styles.campo} ${largo ? styles.campoLargo : ""}`}>
      <span className={styles.rotulo}>{rotulo}</span>
      <span className={vazio ? styles.valorVazio : styles.valor}>{vazio ? "Não informado" : valor}</span>
    </div>
  );
}

/** Mesmo Campo, mas formatando a data (dd/mm/aaaa hh:mm:ss) quando ela existir. */
function CampoData({ rotulo, valor }) {
  const data = valor ? dayjs(valor) : null;
  const valido = data && data.isValid();
  return <Campo rotulo={rotulo} valor={valido ? data.format("DD/MM/YYYY HH:mm:ss") : null} />;
}

export function GroupOrdemServico({ info, setInfo, fetchData, numeroSolicitacao, setIsModalEditarObservacao }) {
  const [isModalEditarObservacacao, setIsModalEditarObservacacao] = useState(false);
  const [loading, setLoading] = useState(false);

  const editarObservacao = (event) => {
    setInfo((prevInfo) => ({
      ...prevInfo,
      observacao: event.target.value,
    }));
  };

  const editar = async () => {
    setLoading(true);
    try {
      const url = `/ordem-servico/observacao/atualizar`;
      const data = {
        id: numeroSolicitacao,
        observacao: info.observacao,
      };

      const responseData = await Method_POST(url, data);

      if (!responseData) {
        throw new Error("Erro ao tentar editar observação");
      }

      fetchData();
      toast.success("Observação alterada com sucesso!");
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  const openModalEditar = () => {
    setIsModalEditarObservacacao(true);
  };

  const closeModalEditar = () => {
    setIsModalEditarObservacacao(false);
  };

  return (
    <>
      <div className={styles.painel}>
        <div className={styles.grupo}>
          <h4 className={styles.grupoTitulo}>Solicitação</h4>
          <div className={styles.grade}>
            <Campo rotulo="Número de Solicitação" valor={info.id} />
            <Campo rotulo="Tipo de Solicitação" valor={info.tipo} largo />
            <Campo rotulo="Código Promocional" valor={info.codigoPromocional} />
            <CampoData rotulo="Data de Solicitação" valor={info.dataSolicitacao} />
            <Campo rotulo="Usuário Atribuição" valor={info.usuarioAtribuicao} />
            <Campo rotulo="Usuário Solicitação" valor={info.usuarioSolicitacao} />
          </div>
        </div>

        <div className={styles.grupo}>
          <h4 className={styles.grupoTitulo}>Situação</h4>
          <div className={styles.grade}>
            <Campo rotulo="Situação" valor={info.situacao} largo />
            <CampoData rotulo="Data Situação" valor={info.dataSituacao} />
            <Campo rotulo="Usuário Situação" valor={info.usuarioSituacao} />
          </div>
        </div>

        <div className={styles.grupo}>
          <h4 className={styles.grupoTitulo}>Histórico de cadastro</h4>
          <div className={styles.grade}>
            <CampoData rotulo="Data Cadastro" valor={info.dataCadastro} />
            <Campo rotulo="Usuário Cadastro" valor={info.usuarioCadastro} />
            <CampoData rotulo="Data Alteração" valor={info.dataAlteracao} />
            <Campo rotulo="Usuário Alteração" valor={info.usuarioAlteracao} />
          </div>
        </div>

        <div className={styles.grupo}>
          <h4 className={styles.grupoTitulo}>Cliente</h4>
          <div className={styles.grade}>
            <Campo rotulo="Cliente ID" valor={info.clienteId} />
            <Campo rotulo="Carteira" valor={info.carteiraId ?? "N/A"} />
            <Campo rotulo="Equipe" valor={info.equipeId ?? "N/A"} />
            <CampoData rotulo="Data Cadastro Cliente" valor={info.dataCadastroCliente} />
            <Campo rotulo="Usuário Cadastro Cliente" valor={info.usuarioCadastroCliente} />
          </div>
        </div>

        <div className={styles.grupo}>
          <h4 className={styles.grupoTitulo}>Empresa</h4>
          <div className={styles.grade}>
            <Campo rotulo="CNPJ" valor={info.cnpj ? formatCNPJ(info.cnpj) : null} />
            <Campo rotulo="Razão Social" valor={info.razaoSocial} largo />
          </div>
        </div>

        <div className={styles.grupo}>
          <div className={styles.observacaoCabecalho}>
            <h4 className={styles.grupoTitulo} style={{ margin: 0 }}>Observação</h4>
            <Button size="small" className={styles.botaoEditar} onClick={openModalEditar}>
              Editar
            </Button>
          </div>
          <p className={info.observacao ? styles.observacaoTexto : styles.observacaoVazia}>
            {info.observacao || "Nenhuma observação"}
          </p>
        </div>
      </div>

      {isModalEditarObservacacao && (
        <ModalWrapper>
          <div className="barra">
            <div className="displayFlex">
              <div className="title">
                <span>Editar Observação</span>
              </div>
              <div className="btn-close" onClick={closeModalEditar}>
                <span className="close">×</span>
              </div>
            </div>
          </div>
          <div className="padding-10-container">
            <div className="container">
              <span className={styles.modalInstrucoesTitulo}>Instruções</span>
              <p className={styles.modalInstrucoes}>
                Edite e salve informações relevantes relacionadas à ordem de serviço.
              </p>
            </div>
            {loading ? (
              <div className={styles.modalCarregando}>
                <Box sx={{ display: "flex" }}>
                  <CircularProgress />
                </Box>
              </div>
            ) : (
              <div>
                <TextArea
                  rows={4}
                  style={{ width: 500, height: 300, margin: "0 auto" }}
                  value={info.observacao}
                  onChange={editarObservacao}
                />

                <div className={styles.modalBotoes}>
                  <Button type="primary" onClick={editar}>
                    Salvar
                  </Button>
                </div>
              </div>
            )}
          </div>
        </ModalWrapper>
      )}
    </>
  );
}

export default GroupOrdemServico;
